/** @format */

import {getDatabase, ref, onValue} from 'firebase/database';
import {KitType, PayDataType} from './Router/types';
import {MethodKeyType} from '../components/Method';
import firebaseApp from '../firebase';

export const sendMessage = (data: any) => {
    // @ts-ignore
    window.top.postMessage(data, '*');
};


export const listenToTransactionStatus = (
    transactionRef: string,
    setTransactionStatus: any,
    setPageTransactionStatus: any
) => {
    const db = getDatabase(firebaseApp);
    const starCountRef = ref(db, 'transactions/' + transactionRef);
    onValue(starCountRef, (snapshot) => {
        const responseStatus = snapshot.val()?.status;
        if (responseStatus === 'successful') {
            setTransactionStatus('success');
            setPageTransactionStatus('success');
            const dataResp = {status: 'successful'};
            setTimeout(() => {
                sendMessage(dataResp);
            }, 5000);
        } else if (responseStatus === 'failed') {
            const dataResp = {status: 'ERROR'};
            setTransactionStatus('error');
            setPageTransactionStatus('error');
            setTimeout(() => {
                sendMessage(dataResp);
            }, 5000);
        }
    });
};

export const listenToCardTransStatus = (
    transactionRef: string, setTransactionStatus: any, setPageTransactionStatus: any) => {
    const db = getDatabase();
    const starCountRef = ref(db, 'transactions/' + transactionRef);
    onValue(starCountRef, (snapshot) => {
        const responseStatus = snapshot.val()?.status;
        if (responseStatus) {
            setTimeout(() => {
                setTransactionStatus('success');
                setPageTransactionStatus('success');
                setTimeout(() => {
                    sendMessage({status: 'successful'});
                }, 5000);
            }, 10000);
        } else {
            setTransactionStatus('error');
            setPageTransactionStatus('error');
            setTimeout(() => {
                sendMessage({status: 'ERROR'});
            }, 5000);
        }
    });
};

export const makeid = () => {
    let result = '';
    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 8; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const acceptedWalletsByCountry = (countryCode?: string, kit?: KitType, currenciesThatAllowBusiness?:string[]): MethodKeyType[] => {
    const walletOptions: Record<string, MethodKeyType[]> = {
        GHS: ['transfer', 'business', 'card'],
        ZMW: ['mobileeast'],
        KES: ['card', 'mobileeast'],
        NGN: ['transfer', 'card', 'ussd'],
        ZAR: ['card', 'transfer'],
        TZS: ['card', 'mobileeast'],
        SLL: ['mobileeast'],
        CDF: ['mobileeast'],
        UGX: ['card', 'mobileeast'],
        XOF: ['mobileeast'],
        XAF: ['mobileeast'],
        RWF: ['mobileeast'],
        MWK: ['mobileeast'],
        CDR: ['mobileeast'],
        USD: ['card'],
    };

    let options = walletOptions[countryCode ?? ""] || ['card'];

    if (countryCode === 'NGN' && kit) {
        const hasPaystack = kit.paystack ?? false;
        if (hasPaystack) {
            options = options.filter(option => !['transfer', 'business'].includes(option));
        }
    }

    if (
        countryCode &&
        currenciesThatAllowBusiness?.includes(countryCode) &&
        !options.includes('business')
    ) {
        options = [...options.slice(0, 1), 'business', ...options.slice(1)];
    }

    return options;
};


export function bankSortFunction(a: any, b: any) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
    }
    return 0;
}